import React, {Component} from 'react'
import {Link} from 'react-router-dom'

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <a href="/privacy.html" className="no-decoration">
          Privacy
        </a>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx